import { render, staticRenderFns } from "./TodayCafePagination.vue?vue&type=template&id=3fa5115e"
import script from "./TodayCafePagination.vue?vue&type=script&lang=js"
export * from "./TodayCafePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports